import MarketingCollateral from 'components/MarketingCollateral';
import type Shipment from 'interfaces/PmParcel';
import { useState } from 'preact/hooks';
import { useFeatureToggleContext } from 'FeatureConfig.context';
import { Campaigns } from './components';

interface FooterBannerProps {
  shipment: Shipment;
}

export const FooterBanner = ({ shipment }: FooterBannerProps) => {
  const featureToggles = useFeatureToggleContext();
  const [isCampaignsEmpty, setIsCampaignsEmpty] = useState(false);

  const isCampaignManagerEnabled = !!featureToggles?.campaignManager?.enable;
  // Show fallback if FT is OFF OR if FT is ON but EMPTY
  const showFallback = !isCampaignManagerEnabled || isCampaignsEmpty;

  return (
    <>
      {isCampaignManagerEnabled && (
        <Campaigns
          shipment={shipment}
          setIsCampaignsEmpty={setIsCampaignsEmpty}
        />
      )}
      {showFallback && <MarketingCollateral />}
    </>
  );
};
